/**
 * @typedef {import('./lib/index.js').Options} Options
 */

export {VFileMessage} from './lib/index.js'
